<div class=" term-condition">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h4 class="">Terms & Conditions</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="terms-content">
          <p [innerHTML]="successResponse"></p>
        </div>
      </div>
    </div>